export enum HoursPickerTimes {
  "morning" = 12,
  "afternoon" = 16,
}
